import Block from '@/components/Block'
import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { coreSectionPaddingClasses } from '@/constants/measured-scope'
import DOMPurify from 'isomorphic-dompurify'
import * as styles from './style'

export interface Props {
  onClickCancel?: () => void
  description?: string
  logo?: string
  name?: string
}

const PartnerInfo = ({ onClickCancel, description, logo, name }: Props): JSX.Element => {
  return (
    <Layout spacing="sm">
      <Block className={`${coreSectionPaddingClasses}`}>
        <Stack y spaceBetweenY="md" className="ta-c">
          {logo ? (
            <div className={styles.logo}>
              <img src={logo} alt={'logo'} data-testid="logo" loading="lazy" />
            </div>
          ) : null}
          {name ? <Text weight="lg">Sponsored by {name}</Text> : null}
          {description ? (
            <Text size="xs" weight="sm">
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(description.replace(/<[^>]+>/g, '')),
                }}
              />
            </Text>
          ) : null}
          <Stack x justifyContent="space-around">
            <Button size="lg" stretch label="Got it!" theme="primary" onClick={onClickCancel} />
          </Stack>
        </Stack>
      </Block>
    </Layout>
  )
}
export default PartnerInfo
